<template>
  <BaseModal
    :show="show"
    height="92%"
    title="Vertrag bearbeiten"
    @close="$emit('update:show', false)"
  >
    <UpdateContract
      v-if="show"
      :contract="contract"
      @close="$emit('update:show', false)"
    />
  </BaseModal>
</template>

<script setup lang="ts">
import UpdateContract from '@/contracts/components/UpdateContract.vue';
import type { Contract } from "@/api/contracts/types";
import BaseModal from '@/application/components/BaseModal.vue';

interface Props {
  show: boolean;
  contract: Contract
}

defineProps<Props>();
defineEmits(['update:show']);
</script>
